module.exports = __webpack_public_path__ + "static/media/0025_IMG_LE_SOL_MEGALITH_MEGABROWN.e61eb28b.webp";